import { render, staticRenderFns } from "./Persoonsgegevens.vue?vue&type=template&id=f14173c6&"
import script from "./Persoonsgegevens.vue?vue&type=script&lang=js&"
export * from "./Persoonsgegevens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports